import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function useQueryMemo() {
	const { search } = useLocation();

	return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default useQueryMemo;
